// ── Competency Building loader ─────────────────────────────────────────────
// Loads competency-based question content for the Competency tab inside the app.
// Content lives under public/data/competency/<chapterKey>.json and a manifest
// at public/data/competency/manifest.json tells us which chapters have content.

const BASE = "/data/competency/";

let manifestPromise = null;
const chapterCache = new Map();

export function loadCompetencyManifest() {
  if (manifestPromise) return manifestPromise;
  manifestPromise = fetch(`${BASE}manifest.json`)
    .then(r => (r.ok ? r.json() : { chapters: {} }))
    .catch(() => ({ chapters: {} }));
  return manifestPromise;
}

export async function loadCompetencyChapter(chapterKey) {
  if (chapterCache.has(chapterKey)) return chapterCache.get(chapterKey);
  try {
    const r = await fetch(`${BASE}${chapterKey}.json`);
    if (!r.ok) {
      chapterCache.set(chapterKey, null);
      return null;
    }
    const data = await r.json();
    chapterCache.set(chapterKey, data);
    return data;
  } catch {
    chapterCache.set(chapterKey, null);
    return null;
  }
}

// Returns chapters available in the manifest for a given class + subject.
// Each entry: { chapterKey, class, subject, chapter, ncertChapter, questionCount, types }
export async function listAvailableCompetencyChapters(cls, subject) {
  const m = await loadCompetencyManifest();
  const out = [];
  for (const [chapterKey, meta] of Object.entries(m.chapters || {})) {
    if (Number(meta.class) === Number(cls) && meta.subject === subject) {
      out.push({ chapterKey, ...meta });
    }
  }
  return out;
}

// Returns true if a given chapterKey has any competency content available.
export async function competencyAvailable(chapterKey) {
  const m = await loadCompetencyManifest();
  return Boolean(m.chapters && m.chapters[chapterKey]);
}
